import React from 'react';
import CalculatorContainer from './components/CalculatorContainer.js'
import './App.css';

function App() {
  return (
    <div className="App">
      <div className = 'App-header'>
        <CalculatorContainer />
      </div>
    </div>
  );
}

export default App;
